import moment from 'moment'
import { CreateProductCatalogPriceDto } from '@services/dtos'

export const getCurrentPrice = (prices: CreateProductCatalogPriceDto[]): CreateProductCatalogPriceDto | undefined => {
  const now = moment()
  const validPrices = prices.filter(({ startAt }) => !startAt || moment(startAt).isBefore(now))
  const activePrice = validPrices.find(({ endAt }) => (moment(endAt).isAfter(now)))
  return activePrice ?? validPrices.sort((a, b) => moment(b.endAt).diff(moment(a.endAt)))[0]
}

export const getDatesPriceLabel = (price: CreateProductCatalogPriceDto | undefined): string | null => {
  if (!price) {
    return null
  }
  const endAtFormatted = moment(price.endAt).format('DD/MM/YYYY')
  return price.startAt 
    ? `Valide du ${moment(price.startAt).format('DD/MM/YYYY')} → ${endAtFormatted}` 
    : `Valide jusqu'au ${endAtFormatted}`
}
